import { render, staticRenderFns } from "./agentmanagelist.vue?vue&type=template&id=228a8954&scoped=true"
import script from "./agentmanagelist.vue?vue&type=script&lang=js"
export * from "./agentmanagelist.vue?vue&type=script&lang=js"
import style0 from "./agentmanagelist.vue?vue&type=style&index=0&id=228a8954&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a8954",
  null
  
)

export default component.exports